"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-right: ", " !important;\n  font-size: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-left: auto;\n  padding-left: ", ";\n  display: flex;\n  align-items: center;\n  > div:not(:last-child) {\n    margin-right: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  margin-bottom: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .ant-picker-calendar-date {\n    height: 150px !important;\n    cursor: default;\n    pointer-events: none;\n    background: transparent !important;\n  }\n  .ant-picker-calendar-date-value {\n    color: ", " !important;\n  }\n  .ant-picker-cell {\n    pointer-events: none;\n    cursor: default;\n  }\n  .ant-picker-calendar-date-content {\n    height: 120px !important;\n    pointer-events: all;\n    padding-bottom: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Calendar = void 0;

var antd_1 = require("antd");

var iconoir_react_1 = require("iconoir-react");

var react_1 = __importDefault(require("react"));

var AntIconWrapper_1 = require("./AntIconWrapper");

var LoadingIndicators_1 = require("./LoadingIndicators");

var Typography_1 = require("./Typography");

var styledTypes_1 = require("./styledTypes");

function Calendar(_a) {
  var loading = _a.loading,
      headerLeft = _a.headerLeft,
      headerRight = _a.headerRight,
      rest = __rest(_a, ["loading", "headerLeft", "headerRight"]);

  return react_1["default"].createElement(Container, null, react_1["default"].createElement(antd_1.Calendar, Object.assign({}, rest, {
    headerRender: function headerRender(_ref) {
      var value = _ref.value,
          onChange = _ref.onChange;
      var previousMonth = value.clone().subtract(1, 'month').format('MMMM YYYY');
      var nextMonth = value.clone().add(1, 'month').format('MMMM YYYY');
      var currentMonth = value.clone().format('MMMM YYYY');
      return react_1["default"].createElement(HeaderContainer, null, react_1["default"].createElement("div", null, headerLeft), react_1["default"].createElement(HeaderRight, null, loading ? react_1["default"].createElement(SpinContainer, null, react_1["default"].createElement(LoadingIndicators_1.LoadingIndicator, null)) : null, react_1["default"].createElement(Typography_1.BodyLarge, {
        weight: Typography_1.FontWeight.Bold,
        style: {
          display: 'inline-block',
          marginRight: '1em'
        }
      }, currentMonth), react_1["default"].createElement(antd_1.Button.Group, null, react_1["default"].createElement(antd_1.Button, {
        icon: react_1["default"].createElement(AntIconWrapper_1.AntIconWrapper, {
          children: react_1["default"].createElement(iconoir_react_1.NavArrowLeft, null)
        }),
        onClick: function onClick() {
          return onChange(value.clone().subtract(1, 'month'));
        }
      }, previousMonth), react_1["default"].createElement(antd_1.Button, {
        onClick: function onClick() {
          return onChange(value.clone().add(1, 'month'));
        }
      }, nextMonth, " ", react_1["default"].createElement(AntIconWrapper_1.AntIconWrapper, {
        children: react_1["default"].createElement(iconoir_react_1.NavArrowRight, null)
      }))), headerRight));
    }
  })));
}

exports.Calendar = Calendar;
var Container = styledTypes_1.styled.div(_templateObject(), function (props) {
  return props.theme['@text-color-secondary'];
}, function (props) {
  return props.theme['@size-xxs'];
});
var HeaderContainer = styledTypes_1.styled.div(_templateObject2(), function (props) {
  return props.theme['@size-m'];
});
var HeaderRight = styledTypes_1.styled.div(_templateObject3(), function (props) {
  return props.theme['@size-s'];
}, function (props) {
  return props.theme['@size-xs'];
});
var SpinContainer = styledTypes_1.styled.div(_templateObject4(), function (props) {
  return props.theme['@size-m'];
}, function (props) {
  return props.theme['@size-s'];
});